// src/components/auth/AuthGuard.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';
import { useAuthCheck } from '../../hooks/useAuthCheck';

function AuthGuard({ children }) {
  const [user, loading] = useAuthState(auth);
  const { status } = useAuthCheck(user);
  const location = useLocation();

  if (loading || status === 'loading') {
    return (
      <div className="min-h-screen bg-[#0A0E23] flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin her zaman erişebilir
  if (user.email === 'zaferkekik@gmail.com') {
    return children;
  }

  // Ödeme ve üyelik sayfalarına her zaman erişilebilir
  if (location.pathname === '/payment' || location.pathname === '/membership') {
    return children;
  }

  // Diğer sayfalara erişim için active status kontrolü
  if (status !== 'active') {
    return <Navigate to="/membership" replace />;
  }

  return children;
}

export default AuthGuard;